/*
* Pipeline Theme - Custom JS
*/

(function() {
  var selectors = {
    stockLabelContainer: 'product-form, [data-product-form], [data-product-form-wrapper]',
    stockLabel: '[data-stock-label]',
    stockLabelText: '[data-stock-label-text]'
  };

  // Cache the inventory data on page load
  var inventoryData = null;
  
  function initInventoryData() {
    var inventoryScript = document.querySelector('[data-product-ships-json]');
    if (inventoryScript) {
      try {
        inventoryData = JSON.parse(inventoryScript.textContent);
      } catch (e) {
        console.error('Error parsing inventory data:', e);
      }
    }
  }

  function getStockLabelContainer(target) {
    if (!target) return null;

    if (target.matches && target.matches(selectors.stockLabelContainer)) {
      return target;
    }

    if (target.closest) {
      return target.closest(selectors.stockLabelContainer);
    }

    return null;
  }

  function updateStockLabel(container, variant) {
    console.log('heree');
    if (!container) return;
    console.log('selectors.stockLabel', selectors.stockLabel);
    console.log('selectors', selectors);
    var label = container.querySelector('[data-stock-label]');
    var labelText = label ? label.querySelector('[data-stock-label-text]') : null;

    if (!label || !labelText) {
      return;
    }

    if (!variant) {
      label.setAttribute('data-hidden', 'true');
      return;
    }

    var inStockCopy = label.getAttribute('data-stock-label-in-stock') || '';
    var outOfStockCopy = label.getAttribute('data-stock-label-out-of-stock') || '';
    
    var useOutOfStockCopy = false;

    // Check if we have inventory data from the JSON
    if (inventoryData && inventoryData.hasOwnProperty(variant.id)) {
      var inventoryCount = inventoryData[variant.id];
      var qty = (inventoryCount === "null" || inventoryCount === null) ? null : parseInt(inventoryCount, 10);
      
      if (qty === null) {
        useOutOfStockCopy = !variant.available;
      } else {
        useOutOfStockCopy = qty <= 0;
      }
    } else {
      useOutOfStockCopy = !variant.available;
    }


    label.removeAttribute('data-hidden');
    labelText.textContent = useOutOfStockCopy ? outOfStockCopy : inStockCopy;
    
    console.log('Variant ID:', variant.id, 'Inventory:', inventoryData ? inventoryData[variant.id] : 'N/A', 'Out of stock?', useOutOfStockCopy);
  }

  // Initialize inventory data when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInventoryData);
  } else {
    initInventoryData();
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail && event.detail.variant ? event.detail.variant : null;
    var container = document; 
    updateStockLabel(container, variant);
    });
})();